const getPreviousYear = () => {
    const d = new Date()
    const pastYear = d.getFullYear() - 1
    return pastYear
}

const infoPanelItems = [
    {
        title: "PTO Balance",
        text: "PTO Balance = PTO Carried over from last year + YTD PTO Accruals + Total PTO Adjustments + Total PTO Approved Paid",
    },
    {
        title: "Actual To Date",
        text: "Total PTO hours unpaid through the end of the current pay period.",
    },
    {
        title: "Total Requested",
        text: "Total Requested hours awaiting approval (paid and unpaid)",
    },
    {
        title: `PTO Carried over from ${getPreviousYear()}`,
        text: "PTO hours carried over from previous year",
    },
    {
        title: "Total PTO Adjustments",
        text: "Total PTO adjustments made to your account by HR",
    },
    {
        title: "YTD PTO Accruals",
        text: "Total PTO accruals",
    },
    {
        title: "Next PTO Accrual",
        text: "PTO hours to be added to current PTO balance on next pay period",
    },
    {
        title: "Total Approved Paid",
        text: "Total Paid hours approved",
    },
    {
        title: "Total PTO Possible",
        text: "Total PTO hours possible by end of year",
    },
    {
        title: "Total Approved Unpaid",
        text: "Total Unpaid hours approved",
    }
]

export default infoPanelItems